import React, { useState, useRef } from 'react';

import { ReactComponent as ArrowDown } from '../../assets/icons/ubr_arrow_down.svg';
import { hash } from '../../utils/hashGenerator';
import { AccordionContent, HeaderTitle, Collapse, BodyContent } from './styles';

interface AccordionProps {
  id?: string;
  title?: string;
  description?: React.ReactNode;
}

export const Accordion: React.FC<AccordionProps> = ({
  id,
  title,
  description,
}) => {
  const [setActive, setActiveState] = useState<string>('');
  const [setHeight, setHeightState] = useState<string>('0px');
  const [setRotate, setRotateState] = useState<string>('accordion__icon');

  const content = useRef<any>();

  const toggleAccordion = () => {
    setActiveState(setActive === '' ? 'active' : '');
    setHeightState(
      setActive === 'active' ? '0px' : `${content.current.scrollHeight}px`,
    );
    setRotateState(
      setActive === 'active' ? 'accordion__icon' : 'accordion__icon rotate',
    );
  };

  return (
    <AccordionContent id={id}>
      <HeaderTitle
        className={`${setActive}`}
        onClick={toggleAccordion}
        tabIndex={0}
        aria-expanded={setActive ? 'true' : 'false'}
        aria-controls={`${hash(title)}-accordion-content`}
      >
        <p>
          {title
            ? title
            : 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita, delectus!'}
        </p>
        <ArrowDown className={`${setRotate}`} width={30} />
      </HeaderTitle>
      <Collapse
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        aria-hidden={setActive ? 'false' : 'true'}
      >
        <BodyContent className={`${setActive}`}>
          <p>
            {description
              ? description
              : 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Voluptatibus non magnam beatae optio ullam provident ipsum consequatur neque quod! Adipisci soluta porro quae. Sint, cupiditate.'}
          </p>
        </BodyContent>
      </Collapse>
    </AccordionContent>
  );
};
